// 🌐 React + Firebase Auth + Router + Context
import React from "react";
import "../CSS/Navbar.css"; // 🖌️ Styling for the navbar
import Icon from "../../media/Icon.png"; // 📷 Logo image
import { signOut } from "firebase/auth"; // 🔌 Logout function
import { auth } from "../../config/firebase-config"; // 🔐 Firebase config
import { useAuthState } from "react-firebase-hooks/auth"; // 👤 Firebase user hook
import { useLocation } from "react-router-dom"; // 📍 To highlight current nav page
import { useQuestions } from "../../contexts/QuestionContext"; // 📊 Access question cost tracking

const Navbar = () => {
  const [user] = useAuthState(auth); // ✅ Get current user (if logged in)
  const location = useLocation();    // 🔎 Detect current route
  const { getSessionCost } = useQuestions(); // 💰 Track session cost from context
  const cost = getSessionCost();     // Get the current cost object

  // 🔒 Sign out logic
  const handleLogout = async () => {
    try {
      await signOut(auth); // 👋 Log out user
      console.log("✅ Logged out");
    } catch (err) {
      console.error("❌ Logout failed:", err); // ⚠️ Log failure
    }
  };

  return (
    <div className="layout-container" dir="rtl">
      {/* 🧱 Top header */}
      <header className="header">
        {/* ⬅️ Logo section */}
        <div className="header-left">
          <div className="logo">
            <img src={Icon} alt="logo" />
          </div>
        </div>

        {/* ➡️ Navigation links and user info */}
        <div className="header-right">
          <nav className="nav-links">
            {/* 🔗 Home link */}
            <a
              href="/"
              className={location.pathname === "/" ? "nav-active" : ""}
            >
              בית
            </a>

            {/* 🔗 Categories link */}
            <a
              href="/categories"
              className={
                location.pathname.includes("/categories") ? "nav-active" : ""
              }
            >
              יחידות לימוד
            </a>

            {/* 💵 Display cost of current session if logged in and cost exists */}
            {user && cost && (
              <span
                className="session-credit"
                title="סך העלות המצטברת במהלך הסשן הנוכחי"
              >
                עלות מצטברת: ${Number(cost?.dollars || 0).toFixed(2)}
              </span>
            )}

            {/* 🔘 Logout button (shown only when logged in) */}
            {user && (
              <button onClick={handleLogout} className="logout-button">
                התנתק
              </button>
            )}
          </nav>
        </div>
      </header>
    </div>
  );
};

export default Navbar;
